import { Breadcrumbs, Link } from '@mui/material';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useRecoilState, useRecoilValue } from 'recoil';
import { previousRouteAtom, selectedDashboardAtom, selectedInstallationAtom } from '../../recoil/atoms';
import { currentSelectedComponentAtom } from '../../recoil/Atom';
import { useEffect, useMemo } from 'react';

type BreadcrumbToken = {
  label: string;
  route: string;
  color?: string;
};
const home: BreadcrumbToken = {
  label: 'Home',
  route: '/installations',
};

const BC = () => {
  const navigate = useNavigate();
  const currentRoute = useLocation()
  const [previousRoute] = useRecoilState(previousRouteAtom)

  const { installationId, dashboardId, componentId } = useParams();

  const selectedInstallation = useRecoilValue(selectedInstallationAtom);
  const selectedDashboard = useRecoilValue(selectedDashboardAtom);
  const currentSelectedComponent = useRecoilValue(currentSelectedComponentAtom);

  useEffect(() => {
    console.log(currentSelectedComponent)
  }, [currentSelectedComponent]);


  const breadcrumbsTokens = useMemo<BreadcrumbToken[]>(() => {

    const tokens: BreadcrumbToken[] = [home];

    if (installationId && selectedInstallation) {
      tokens.push({
        label: selectedInstallation.name,
        route: `/installation/${installationId}`,
      });
    }

    if (dashboardId && selectedDashboard) {
      tokens.push({
        label: selectedDashboard.name,
        route: `/installation/${installationId}/dashboard/${dashboardId}`,
      });
    }

    if (componentId && currentSelectedComponent) {
      tokens.push({
        label: currentSelectedComponent.name,
        route: `/installation/${installationId}/dashboard/${dashboardId}/component/${componentId}`,
      });
    }
    if (currentRoute.pathname.includes('requests')) {
      tokens.push({
        label: 'Notifications',
        route: previousRoute,
      });
    }
    if (currentRoute.pathname.includes('debug')) {
      tokens.push({
        label: 'Debug',
        route: previousRoute,
      });
    }
    tokens.forEach((token, index) => {
      token.color = index === tokens.length - 1 ? 'secondary.main' : 'inherit';
    });

    return tokens;

  }, [installationId, dashboardId, selectedInstallation, selectedDashboard, componentId, currentSelectedComponent, currentRoute]);

  return (
    <Breadcrumbs
      separator=">"
      sx={{
        pl: 2,
        height: '100%',
        fontSize: 'small',
        alignItems: 'center',
      }}
    >
      {breadcrumbsTokens.map((token, index) => (
        <Link
          key={index}
          underline="hover"
          color={token.color}

          sx={{
            cursor: 'pointer',
            fontWeight: 900,
            letterSpacing: 1
          }}
          onClick={() => navigate(token.route)}
        >
          {token.label}
        </Link>
      ))}
    </Breadcrumbs>
  );
};

export default BC;
